<template>
    <div
        :class="mainContainerClasses"
        class="gap-8"
    >
        <div :class="leftContainerClasses">
            <div>
                <slot name="left" />
            </div>
        </div>
        <div :class="rightContainerClasses">
            <div>
                <slot name="right" />
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
    const props = defineProps({
        mainContainerClasses: {
            type: String,
            default: 'grid grid-cols-12',
        },
        leftContainerClasses: {
            type: String,
            default: 'col-span-12 lg:col-span-4',
        },
        rightContainerClasses: {
            type: String,
            default: 'col-span-12 lg:col-span-8',
        },
    })
</script>
